import { getHandler } from 'src/utils/fetchHandler';

export const CLEAR_GIFTS = 'CLEAR_GIFTS/GIFTS/@WISELY/WEB';
export const GET_GIFTS = 'GET_GIFTS/GIFTS/@WISELY/WEB';
export const FETCH_GIFTS_FAILED = 'FETCH_GIFTS_FAILED/GIFTS/@WISELY/WEB';
export const FETCH_GIFTS_SUCCEEDED = 'FETCH_GIFTS_SUCCEEDED/GIFTS/@WISELY/WEB';
export const SET_SORT_BY = 'SET_SORT_BY/GIFTS/@WISELY/WEB';

export const clearGifts = () => ({
	type: CLEAR_GIFTS,
});

export const getGifts = () => ({
	type: GET_GIFTS,
});

export const fetchGiftsSucceeded = payload => ({
	type: FETCH_GIFTS_SUCCEEDED,
	payload,
});

export const fetchGiftsFailed = payload => ({
	type: FETCH_GIFTS_FAILED,
	payload,
});

export const fetchGifts = params => {
	return dispatch => {
		dispatch(getGifts());
		const path = `v2/gifts`;

		return getHandler(path, params)
			.then(json => dispatch(fetchGiftsSucceeded(json)))
			.catch(error => {
				console.error('fetchGifts error', error);
				dispatch(fetchGiftsFailed(error));
			});
	};
};

export const setSortBy = settings => ({
	type: SET_SORT_BY,
	payload: settings,
});



// WEBPACK FOOTER //
// ./src/redux/gifts/gifts.action.js